import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { environment, Confirm_button, SSOURL } from '../../../environments/environment';
import * as fromStore from '../../store';
import * as fromFeature from '../../my-features';
import { OAuthLoginMessage, CheckAuthOtpErrMsg, AuthOtpType, OAuthPurposeType, OAuthPlatformType } from '../../shareModel';
import { AccountOauthParam, OauthLoginParam } from '../../my-features/account/oauth.model';
import { AccountService } from '../../services/account.service';
import { UserService } from '../../services/user.service';
import { UtilsService } from '../../services/utils.service';
import { MessageService } from 'primeng/api';

@Component({
  standalone: false,
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css']
})
export class SSOComponent implements OnInit, OnDestroy {

  private componentDestroyed = new Subject();

  AccountEmail: string;
  Country = null;
  LoginLocked = false;
  LoginLockedMessage: string;
  loginFail = false;
  isLogging = false;
  socialEmailRegisterAlert = false;
  SSOAccountNotFoundAlert = false;
  AddOauthparam: AccountOauthParam = {
    Code: '',
    RegisterSys: 1,
    RegisterType: 0,
    Purpose: OAuthPurposeType.AddAccountFromWeb
  };
  Confirm_button = Confirm_button;

  public form: FormGroup;
  socialType: string;
  inputType = 'password';
  showPasswordIcon: Boolean = false;
  saveDirty = false;
  constructor(private fb: FormBuilder,
    private store: Store<fromStore.State>,
    private router: Router,
    private ngxService: NgxUiLoaderService,
    private apiService: AccountService,
    private userService: UserService,
    private utils: UtilsService,
    private messageService: MessageService) {
      this.store.select(fromStore.getCurrentUser)
      .subscribe(res => {
        if (res.isLoading) {
          this.isLogging = true;
        } else {
          this.isLogging = false;
          // this.ngxService.stop();
        }
        const pathname = window.location.pathname;
        if (!res.isLoading && res.isLoaded && res.isLogin && pathname === '/login/sso') {
          // tslint:disable-next-line:max-line-length
          if (this.userService.GetRedirect !== 'null' && this.userService.GetRedirect !== null && this.userService.GetRedirect !== '/' && this.userService.GetRedirect !== '/index' && this.userService.GetRedirect !== pathname) {
            this.router.navigate([this.userService.GetRedirect]);
          } else {
            this.router.navigate(['/index']);
          }
        } else if (!res.isLogin && res.isLoaded && !res.isLoading) {
          this.loginFail = true;
          if (res.Message && res.Message.includes('lock')) {
            this.LoginLockedMessage = res.Message;
            this.LoginLocked = true;
          }
        }
      });

      router.events.subscribe(s => {
        if (s instanceof NavigationEnd) {
          if (s.url.indexOf('?') !== -1) {
            const params = new URLSearchParams(s.url.split('?')[1]);
            const param_error = params.get('error');
            if (param_error) {
              // remove redirect param
              window.history.pushState({}, document.title, '/login/sso' );
              // sso login error message
              // const error_message = decodeURIComponent(atob(param_error));
              // console.log(error_message);
              // this.messageService.add({ severity: 'error',
              // summary: error_message });
              this.SSOAccountNotFoundAlert = true;
            }
          }
        }
      });
   }

  ngOnInit() {
    const token = JSON.parse(this.utils.getToken());
    const ssocookie = (token && token.ssocookie) ? token.ssocookie : '';
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('body-login');
    body.classList.remove('body-landing');
    body.classList.remove('mobile-toggle');
    body.classList.remove('body-help');

    this.form = this.fb.group({
      accountEmail: [ssocookie, Validators.pattern('^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$')],
      password: ['', Validators.pattern('^[a-zA-Z0-9-_]{5,20}')]
    });

  }
  get accountEmail() { return this.form.get('accountEmail'); }
  get password() { return this.form.get('password'); }


  ssoLogin(email) {
    if (email.status === 'INVALID') {
      this.saveDirty = true;
      return;
    } else {
      this.saveDirty = false;
      this.ssoLoginRedirect();
    }
  }

  accountEmailChange() {
    this.saveDirty = false;
  }

  passwordChange(password: string) {
    if (password.length > 0) {
      this.showPasswordIcon = true;
    } else if (password.length === 0) {
      this.showPasswordIcon = false;
      this.inputType = 'password';
    }
  }

  handleChange(e: any) {
    const isChecked = e.checked;
    if (isChecked) {
      this.inputType = 'text';
    } else {
      this.inputType = 'password';
    }
  }

  socialLogin(socialType) {
    this.socialType = socialType;

    if (socialType === 'apple') {
      // tslint:disable-next-line:max-line-length
      let url = environment.PowerPanelCloudAppleOAuthUrl.replace('{0}', environment.RedirectAuthApiUrl);
      url = url.replace('{1}', '&state=login');
      window.location.href = url;
    }
    if (socialType === 'google') {
      let url = environment.PowerPanelCloudGoogleOAuthUrl.replace('{0}', environment.HomePageUrl);
      url = url.replace('{1}', '');
      window.location.href = url;
    }
    // 2026/07/21 kyrie.hung 移除 Facebook 登入功能
    // if (socialType === 'facebook') {
    //   let url = environment.PowerPanelCloudFacebookOAuthUrl.replace('{0}', environment.HomePageUrl);
    //   url = url.replace('{1}', '');
    //   window.location.href = url;
    // }
  }

  closeDialog() {
    this.isLogging = false;
    this.LoginLocked = false;
    this.SSOAccountNotFoundAlert = false;
    // this.TwoFactorAuthDialog = false;
  }

  ssoLoginRedirect() {
    this.utils.writeToken({ ssocookie: this.form.value.accountEmail });
    const domain = this.form.value.accountEmail.substring(this.form.value.accountEmail.indexOf('@') + 1);
    const obj = {
      MSPDomain: domain,
      SSOEmail: this.form.value.accountEmail.trim()
    };
    const encodedparam = window.btoa(JSON.stringify(obj));
    // const url = 'http://localhost:8080/sso/login?param=' + encodedparam;
    // const url = 'https://powerpaneldemo.cyberpower.com/sso/login?param=' + encodedparam;
    const url = SSOURL.backendURL + '/sso/login?param=' + encodedparam;
    window.location.href = url;
  }

  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
